export const GET_PRODUCTS_DATA_REQUEST = "GET_PRODUCTS_DATA_REQUEST";

export const GET_PRODUCTS_DATA_SUCCESS = "GET_PRODUCTS_DATA_SUCCESS";

export const GET_PRODUCTS_DATA_FAILURE = "GET_PRODUCTS_DATA_FAILURE";


// -------------------------




export const GET_SINGLE_PRODUCT_REQUEST = "GET_SINGLE_PRODUCT_REQUEST";

export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";

export const GET_SINGLE_PRODUCT_FAILURE = "GET_SINGLE_PRODUCT_FAILURE";


// ------------------------

export const ADD_PRODUCT_CART_REQUEST = "ADD_PRODUCT_CART_REQUEST";

export const ADD_PRODUCT_CART_SUCCESS = "ADD_PRODUCT_CART_SUCCESS";

export const ADD_PRODUCT_CART_FAILURE = "ADD_PRODUCT_CART_FAILURE";

// ------------------------

export const ADD_PRODUCT_WISH_REQUEST = "ADD_PRODUCT_WISH_REQUEST";

export const ADD_PRODUCT_WISH_SUCCESS = "ADD_PRODUCT_WISH_SUCCESS";

export const ADD_PRODUCT_WISH_FAILURE = "ADD_PRODUCT_WISH_FAILURE";

// -------------------------

export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";

export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";

export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";


// --------------------------

export const FETCH_WISH_REQUEST = "FETCH_WISH_REQUEST";

export const FETCH_WISH_SUCCESS = "FETCH_WISH_SUCCESS";

export const FETCH_WISH_FAILURE = "FETCH_WISH_FAILURE";


// -------------------------

export const REMOVE_PRODUCT_CART_REQUEST = "REMOVE_PRODUCT_CART_REQUEST";

export const REMOVE_PRODUCT_CART_SUCCESS = "REMOVE_PRODUCT_CART_SUCCESS";

export const REMOVE_PRODUCT_CART_FAILURE = "REMOVE_PRODUCT_CART_FAILURE";

// -----------------------------

export const REMOVE_PRODUCT_WISH_REQUEST = "REMOVE_PRODUCT_WISH_REQUEST";

export const REMOVE_PRODUCT_WISH_SUCCESS = "REMOVE_PRODUCT_WISH_SUCCESS";

export const REMOVE_PRODUCT_WISH_FAILURE = "REMOVE_PRODUCT_WISH_FAILURE";

// ---------------------------

export const ADD_ORDER_REQUEST = "ADD_ORDER_REQUEST";

export const ADD_ORDER_SUCCESS = "ADD_ORDER_SUCCESS";

export const ADD_ORDER_FAILURE = "ADD_ORDER_FAILURE";

// ----------------------------

export const EMPTY_CART_REQUEST = "EMPTY_CART_REQUEST";

export const EMPTY_CART_SUCCESS = "EMPTY_CART_SUCCESS";

export const EMPTY_CART_FAILURE = "EMPTY_CART_FAILURE";


// -----------------------------


export const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";

export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";

export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";


// -----------------------------

export const REMOVE_PRODUCT_ORDER_REQUEST = "REMOVE_PRODUCT_ORDER_REQUEST";

export const REMOVE_PRODUCT_ORDER_SUCCESS = "REMOVE_PRODUCT_ORDER_SUCCESS";

export const REMOVE_PRODUCT_ORDER_FAILURE = "REMOVE_PRODUCT_ORDER_FAILURE";